import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { useIntersectionObserver } from './useIntersectionObserver';
export function PainTable() {
  const {
    elementRef,
    isVisible
  } = useIntersectionObserver();
  const errors = [{
    title: 'Creer que una declaración enviada es una declaración terminada.',
    description: '(Falso: Tienes 3 años para corregirla y pedir más dinero).'
  }, {
    title: 'Dejar de reclamar a hijos que trabajan.',
    description: '(Creen que si el hijo tiene un part-time, ya no cuenta. Error de miles de dólares).'
  }, {
    title: 'Pagarle todo el balance al IRS de golpe.',
    description: '(Vaciando sus ahorros cuando el IRS ofrece planes de pago que te permiten usar ese capital para invertir).'
  }];
  return <section className="bg-navy-dark py-16 md:py-24" data-id="element-109">
      <div ref={elementRef} className={`max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 fade-in-section ${isVisible ? 'is-visible' : ''}`} data-id="element-110">
        <div className="text-center mb-12" data-id="element-111">
          <AlertTriangleIcon className="w-12 h-12 text-red-500 mx-auto mb-4" data-id="element-112" />
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-113">
            He visto a personas cometer estos{' '}
            <span className="text-red-400" data-id="element-114">3 errores fatales</span> año tras
            año:
          </h2>
        </div>

        <div className="space-y-6" data-id="element-115">
          {errors.map((error, index) => <div key={index} className="bg-navy-light p-6 md:p-8 rounded-xl border border-white/10 flex gap-4 md:gap-6 items-start" data-id="element-116">
              <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 bg-red-500/20 text-red-400 rounded-full flex items-center justify-center font-bold text-xl border border-red-500/30" data-id="element-117">
                {index + 1}
              </div>
              <div data-id="element-118">
                <h3 className="text-xl md:text-2xl font-bold text-white mb-2" data-id="element-119">
                  {error.title}
                </h3>
                <p className="text-lg md:text-xl text-gray-400" data-id="element-120">
                  {error.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}